import { render, staticRenderFns } from "./ViewTemplatesEmailMjml.vue?vue&type=template&id=b24f3bb0&"
import script from "./ViewTemplatesEmailMjml.vue?vue&type=script&lang=js&"
export * from "./ViewTemplatesEmailMjml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports